import { useCallback } from "react";
import { useIonModal } from "@ionic/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { RequestModel } from "../../model/RequestModel";
import { cancelRequest } from "../../utils/api";
import { CancelRequestModal, type CancelRequestState } from "../CancelRequest";

export const useCancelRequest = (request: RequestModel) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (payload: Record<string, string | boolean>) => {
      return cancelRequest(request.id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["requests"] });
    },
  });
  const onCancelRequestSubmit = async (state: CancelRequestState) => {
    try {
      await mutation.mutateAsync({
        reason: state?.cancelReason || "",
        explanation: state.cancelExplanation || "",
        "should-repost": state.shouldRepost || false,
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_) {
      return { isSuccess: false };
    }

    return { isSuccess: true };
  };
  const [presentCancelRequestModal, dismissCancelRequestModal] = useIonModal(CancelRequestModal, {
    request,
    onDismiss: (data?: unknown, role?: string) => {
      dismissCancelRequestModal(data, role);
    },
    onSubmit: onCancelRequestSubmit,
  });
  const openCancelRequestModal = useCallback(() => {
    presentCancelRequestModal();
  }, [presentCancelRequestModal]);

  return { openCancelRequestModal };
};
